"use client";

import { useProductViewStorage } from "@/hooks/useProductViewStorage";

export interface ProductViewTrackerProps {
  productId: string;
  productType: "course" | "program" | "exec-ed" | "degree";
  productName: string;
  productUrl: string;
  checkoutUrl: string;
  courseId?: string;
  metadata?: {
    price?: number;
    discountedPrice?: number;
    currency?: string;
    partner?: string;
    category?: string;
    enrollmentStart?: string;
    enrollmentEnd?: string;
    courseRunEnd?: string;
  };
}

export function ProductViewTracker({
  productId,
  productType,
  productName,
  productUrl,
  checkoutUrl,
  courseId,
  metadata,
}: ProductViewTrackerProps) {
  useProductViewStorage(
    productId,
    productType,
    productName,
    productUrl,
    checkoutUrl,
    courseId,
    metadata,
  );

  return null;
}
